export enum TrackingGroup {
    DAY = 'day',
    MONTH = 'month'
}